"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("../../../util");
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const TxTypes = {
    CreateOrder: "order/CreateOrder",
    CancelOrder: "order/CancelOrder",
    EditOrder: "order/EditOrder",
    CancelAll: "order/CancelAll",
};
const MsgCreateOrder = {
    aminoType: TxTypes.CreateOrder,
    valueMap: {
        price: utils_1.ConvertEncType.Dec,
        stopPrice: utils_1.ConvertEncType.Dec,
    },
};
const MsgCancelOrder = {
    aminoType: TxTypes.CancelOrder,
    valueMap: {},
};
const MsgEditOrder = {
    aminoType: TxTypes.EditOrder,
    valueMap: {
        price: utils_1.ConvertEncType.DecOrZero,
        stopPrice: utils_1.ConvertEncType.DecOrZero,
    },
};
const MsgCancelAll = {
    aminoType: TxTypes.CancelAll,
    valueMap: {},
};
const createOrderProcess = {
    toAminoProcess: (amino, input) => {
        const newInput = input;
        if (!input.isPostOnly) {
            delete newInput.isPostOnly;
        }
        if (!input.isReduceOnly) {
            delete newInput.isReduceOnly;
        }
        if (input.timeInForce === "") {
            delete newInput.timeInForce;
        }
        if (input.triggerType === "") {
            delete newInput.triggerType;
        }
        newInput.stopPrice = input.stopPrice === "" ? "0" : input.stopPrice;
        newInput.price = input.price === "" ? "0" : input.price;
        return { amino, input: newInput };
    },
    fromAminoProcess: (amino, input) => {
        var _a, _b, _c, _d;
        const newInput = Object.assign(Object.assign({}, input), { is_post_only: (_a = input.is_post_only) !== null && _a !== void 0 ? _a : false, is_reduce_only: (_b = input.is_reduce_only) !== null && _b !== void 0 ? _b : false, time_in_force: (_c = input.time_in_force) !== null && _c !== void 0 ? _c : "", trigger_type: (_d = input.trigger_type) !== null && _d !== void 0 ? _d : "", stop_price: util_1.NumberUtils.bnOrZero(input.stop_price, util_1.NumberUtils.BN_ZERO).eq(0) ? "" : input.stop_price, price: util_1.NumberUtils.bnOrZero(input.price, util_1.NumberUtils.BN_ZERO).eq(0) ? "" : input.price });
        return { amino, input: newInput };
    },
};
const OrderAmino = {
    [CarbonTx.Types.MsgCreateOrder]: utils_1.generateAminoType(MsgCreateOrder, createOrderProcess),
    [CarbonTx.Types.MsgCancelOrder]: utils_1.generateAminoType(MsgCancelOrder),
    [CarbonTx.Types.MsgEditOrder]: utils_1.generateAminoType(MsgEditOrder),
    [CarbonTx.Types.MsgCancelAll]: utils_1.generateAminoType(MsgCancelAll),
};
exports.default = OrderAmino;
